import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { convertMarkingsToCollection } from 'chessboard/plugins/markings/model/convert-markings-to-collection';

/**
 * Create the getMarkings method.
 */
export function createGetMarkings(context: API.Context) {
  /**
   * Return the current game markings.
   */
  return function getMarkings(): Game.Node.Marking.Collection {
    const { api } = context;
    const markings = <Markings.API>api.markings;

    return convertMarkingsToCollection(markings.getAll());
  };
}
